import logger from "~/lib/logger";

declare global {
  interface Window {
    hsConversationsSettings?: {
      identificationEmail?: string;
      identificationToken?: string;
    };
  }
}

export const init = async (): Promise<void> => {
  const element = document.querySelector<HTMLElement>(
    "[data-hubspot-identification-url]",
  );
  const url = element?.dataset.hubspotIdentificationUrl;
  if (!url) return;
  element.remove();

  try {
    const response = await fetch(url);
    if (!response.ok) return;
    window.hsConversationsSettings = await response.json();

    const script = document.createElement("script");
    script.id = "hs-script-loader";
    script.src = "https://js-eu1.hs-scripts.com/144667663.js";
    script.async = true;
    document.body.append(script);
  } catch (error) {
    logger().warn("Failed to initialize HubSpot", error);
  }
};
